import React from 'react';
import styled from 'styled-components';

const StyledGridContainer = styled.div`
  margin: 0 auto;
  max-width: ${({
    theme: {
      grid: { maxWidth },
    },
  }) => maxWidth};
`;

export default function GridContainer(props) {
  return <StyledGridContainer>{props.children}</StyledGridContainer>;
}
